const apiUrl = process.env.REACT_APP_API_URL;
const baseAuth = process.env.REACT_APP_BASE_AUTH;
const gtmId = process.env.REACT_APP_GTM_ID;
const type = (process.env.REACT_APP_ENVIRONMENT || 'development') as
  | 'development'
  | 'production';
const isDevelopment = type === 'development';

export const environment = {
  apiUrl,
  baseAuth,
  gtmId,
  type,
  isDevelopment,
};
